import { Controller } from "@hotwired/stimulus";

  export default class extends Controller {
    static targets = ["budget", "cost"];
    static values = { percentage: String };
    
    apply(event){
      if(this.hasCostTarget){
        var budget = $("#job_budget").val();
          if ($(this.costTarget).val().length > 0) {
            return;
          }
          budget = $(this.budgetTarget).val();
          var targetCost = Math.round(budget * this.percentageValue);
          $(this.costTarget).val(targetCost);
      }     
    }
  }